<template>
  <div v-click-outside="onBlur" class="cur-selector" :class="{ 'cur-selector_open': open }">
    <div class="cur-selector__chosen" @click="toogleCurrencySelector" :class="{'cur-selector__chosen_long': long}">
      <currency-icon :currencyId="value.id" class="cur-selector__chosen-icon"/>
      <div class="cur-selector__chosen-text" :title="value.name">
        {{ value.name }}
        <div class="cur-selector__chosen-abbreviation" v-if="long">({{value.symbol}})</div>
      </div>
      <div class="cur-selector__chosen-arrow"></div>
    </div>
    <div class="cur-selector__popup">
      <div class="cur-selector__popup-first-section">
        <div class="cur-selector__popup-title">Search among {{totalRowsCount}} currencies</div>
        <search-control
          id="cur-selector-control"
          placeholder="Currency name or ticker"
          @onResultClick="selectCurrency"
          @onEnterPress="selectCurrency"
        ></search-control>
      </div>
      <div class="cur-selector__popup-second-section" v-if="top10Currencies.length">
        <div class="cur-selector__popup-title">Don’t know where to start?</div>
        <div class="cur-selector__popup-subtitle">Start with the top 10 from {{totalRowsCount}} currencies</div>
        <div class="cur-selector__top10">
          <button
            v-for="(item, key) in top10Currencies"
            :key="item.id"
            :title="getTop10ItemName(item)"
            @click="selectCurrency(item)"
            class="cur-selector__top10-item"
          >
            {{ `${key + 1}. ${getTop10ItemName(item)}` }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* @Flow */
import { mapState, mapGetters } from 'vuex';

export default {
  props: {
    value: Object,
    options: Array,
    long: Boolean,
  },
  data: () => ({
    open: false,
    top10Currencies: [], // TODO maybe we can use values from store?
  }),
  created() {
    this.$apiService.getTickers({ limit: 10 }).then((data) => {
      this.top10Currencies = data.rows;
    });
  },
  computed: {
    ...mapState('tickers', ['totalRowsCount']),
    ...mapGetters('tickers', ['searchControlPlaceholder']),
  },
  methods: {
    toogleCurrencySelector() {
      this.open = !this.open;
    },
    onBlur() {
      this.open = false;
    },
    getTop10ItemName(currency) {
      return `${currency.name} (${currency.symbol})`;
    },
    selectCurrency(item) {
      this.open = false;
      this.$emit('input', item);
    },
  },
};
</script>

<style lang="scss">
.cur-selector {
  position: relative;
  display: inline-block;
  $height: 60px;
  &__chosen {
    width: 240px;
    height: $height;
    background: $white-color2;
    box-shadow: 2px 2px 30px $black-color2;
    border-radius: 5px;
    position: relative;
    display: flex;
    align-items: center;
    cursor: pointer;
    user-select: none;
    &_long {
      width: 100%;
      .cur-selector__chosen-icon {
        width: 23px;
        margin-left: 20px;
      }
      .cur-selector__chosen-text {
        margin-left: 17px;
        font-size: 17px;
      }
      .cur-selector__chosen-abbreviation {
        display: inline-block;
      }
      .cur-selector__chosen-arrow {
        right: 22px;
        top: 27px;
      }
    }
  }
  &__chosen-arrow {
    background: url("~src/assets/svg/arrow.svg") no-repeat;
    transform: rotate(180deg);
    transition: $transition transform ease-out;
    width: 12px;
    height: 8px;
    position: absolute;
    right: 20px;
    top: 28px;
  }
  &_open {
    .cur-selector__chosen-arrow {
      transform: rotate(0deg);
    }
    .cur-selector__popup {
      display: block;
    }
  }
  &__chosen-icon {
    width: 24px;
    height: 24px;
    margin-left: 18px;
  }
  &__chosen-text {
    @include font(15px, $black-color1, 500);
    @include trimOverflowText(calc(100% - 100px));
    margin-left: 15px;
  }
  &__popup {
    background: $white-color2;
    box-shadow: 4px 4px 16px $black-color4;
    border-radius: 5px;
    position: absolute;
    top: $height + 5px;
    left: 0;
    width: 376px;
    height: 461px;
    z-index: 9999;
    display: none;
  }
  &__popup-title {
    @include font(17px, $black-color1, 500);
    margin-bottom: 15px;
  }
  &__popup-subtitle {
    font-size: 13px;
    margin-bottom: 31px;
  }
  $column-width: 141px;
  &__top10 {
    height: 145px;
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
  }
  &__top10-item {
    @include removeBtnDefaults;
    @include font(13px, $red-color3, 500);
    line-height: 29px;
    cursor: pointer;
    width: $column-width;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
  &__popup-first-section {
    padding: 40px 30px;
    border-bottom: 1px solid $white-color1;
  }
  &__popup-second-section {
    padding: 33px 30px;
  }
}
@media screen and (max-width: 425px) {
  .cur-selector {
    position: static;
    &__popup {
      left: 5px;
      right: 5px;
      max-width: calc(100vw - 10px);
      top: auto;
      margin-top: 15px;
      height: 432px;
    }
    &__popup-second-section {
      padding-left: 20px;
      padding-right: 20px;
    }
    &__popup-title {
      font-size: 15px;
    }
    &__popup-subtitle {
      font-size: 11px;
    }
    &__top10 {
      height: 129px;
    }
    &__top10-item {
      font-size: 11px;
      line-height: 24px;
      width: 45%;
    }
  } 
}
</style>




// WEBPACK FOOTER //
// src/components/uikit/CurrencySelector.vue